/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import GridItem from '../../components/Grid/GridItem';
import { PlkField } from '../../modules/plkFunctions/PlkTypesInterface';
import GridContainer from '../../components/Grid/GridContainer';
import GetSubscription from '../../modules/plkFunctions/GetRequestSubscriptionDefault';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import SetClientDefault from '../../modules/plkFunctions/SetClientDefault';

const _ = require('underscore');

interface PlkResponseViewInterface {
    getSubscription: GetSubscription | SetClientDefault;
    item: MvnoOperation;
    counter: number;
}

export const PlkResponseView: FunctionComponent<PlkResponseViewInterface> = ({ getSubscription, item, counter }) => {
    return (
        <GridContainer>
            <GridItem xs={12}>
                <Typography variant="subtitle2">
                    <I18n trans="prov:vb.response_parameter" />
                </Typography>
            </GridItem>
            {getSubscription.getResponseParameter(counter - 1).map((i: PlkField) => {
                if (!_.isArray(i.value)) {
                    if (i.key === 'responseTime') {
                        return (
                            <React.Fragment key={i.value + i.key}>
                                <GridItem xs={6}>
                                    <I18n trans="prov:vb.block_end" />
                                </GridItem>
                                <GridItem xs={6}>{i.value}</GridItem>
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <React.Fragment key={i.value + i.key}>
                                <GridItem xs={6}>
                                    <b>{i.key}</b>
                                </GridItem>
                                <GridItem xs={6}>{i.value}</GridItem>
                            </React.Fragment>
                        );
                    }
                } else if (i.key === 'items' && Array.isArray(i.value)) {
                    return (
                        <React.Fragment key={i.value + i.key}>
                            <GridItem xs={12}>
                                <b>
                                    <I18n trans="prov:vb.response_elements" />
                                </b>
                            </GridItem>
                            <GridItem xs={1}></GridItem>
                            <GridItem xs={11}>
                                <GridContainer style={{ marginTop: '5px', marginBottom: '5px' }}>
                                    {i.value.map((v1: PlkField) => {
                                        return (
                                            <React.Fragment key={v1.key + v1.value}>
                                                <GridItem xs={6}>
                                                    <b>{v1.key}</b>
                                                </GridItem>
                                                <GridItem xs={6}>{v1.value}</GridItem>
                                            </React.Fragment>
                                        );
                                    })}
                                </GridContainer>
                            </GridItem>
                        </React.Fragment>
                    );
                }
            })}
        </GridContainer>
    );
};
